import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { allAccountsGroupedByProviderAndOrgSelector } from "../all-providers/allAccountsGroupedByProviderAndOrgSelector";
import { allAccountsGroupedByOrgsCombiner } from "../../combiners/allAccountsGroupedByOrgsCombiner";

export const awsAllAccountsGroupedByOrgsSelector = createDraftSafeSelector(
  [allAccountsGroupedByProviderAndOrgSelector],
  allAccountsGroupedByOrgsCombiner("aws"),
);
